import PageTitleButton from "./PageTitleButton";

export default PageTitleButton;
